// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"88f1c48a","455":"d7674eeb","977":"93f5b651"}[chunkId] + ".chunk.js";
};